module.exports = __webpack_public_path__ + "media/images/lp-add-user-icon@2x-b6e3c9139831bb518a59443f1469ad8d.png";